import { render, staticRenderFns } from "./localMenuGroupsSelectorDialog.vue?vue&type=template&id=4213a9f4"
import script from "./localMenuGroupsSelectorDialog.vue?vue&type=script&lang=js"
export * from "./localMenuGroupsSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./localMenuGroupsSelectorDialog.vue?vue&type=style&index=0&id=4213a9f4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4213a9f4')) {
      api.createRecord('4213a9f4', component.options)
    } else {
      api.reload('4213a9f4', component.options)
    }
    module.hot.accept("./localMenuGroupsSelectorDialog.vue?vue&type=template&id=4213a9f4", function () {
      api.rerender('4213a9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/centricOS-local-menu-group-permissions/localMenuGroupsSelectorDialog.vue"
export default component.exports